const vapidPublicKey = "BPaofrhMk81txQuL8o00Vfghcp-pN0pnmqoHHiDmlCqBJmitvxiOJGJiWJUpua8qF98C4sPW1YGE2mFU9qHPlqA";

document.addEventListener("DOMContentLoaded", function() {
    initSubscription();
});

async function initSubscription() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn("Push y Service Workers no están soportados por este navegador.");
        return;
    }

    try {
        const swReg = await navigator.serviceWorker.ready;

        const permission = await getNotificationPermission();
        if (permission !== "granted") {
            console.warn("Permiso para notificaciones no concedido.");
            return;
        }

        const subscription = await getOrCreateSubscription(swReg);
        const coords = await getLocationOrNull();

        await enviarSuscripcion(subscription, coords.latitude, coords.longitude);
    } catch (error) {
        if (error && (error.name === "AbortError" || error.name === "NotAllowedError")) {
            // El servicio push del navegador puede estar temporalmente caído o
            // bloqueado. No afecta el resto de la página y se reintentará en
            // una próxima visita.
            console.info("La suscripción push no está disponible temporalmente.");
            return;
        }
        console.error("Error al inicializar la suscripción:", error);
    }
}

async function getNotificationPermission() {
    if (!("Notification" in window)) {
        return "denied";
    }

    if (Notification.permission === "granted") {
        return "granted";
    }

    if (Notification.permission === "denied") {
        return "denied";
    }

    return await Notification.requestPermission();
}

async function getOrCreateSubscription(swReg) {
    const existingSubscription = await swReg.pushManager.getSubscription();
    if (existingSubscription) {
        return existingSubscription;
    }

    return await swReg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });
}

function getLocationOrNull() {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            resolve({ latitude: null, longitude: null });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            function(position) {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            function() {
                // La ubicación es opcional. Un permiso denegado, un timeout o
                // un dispositivo sin posición disponible no impiden registrar
                // la suscripción push.
                resolve({ latitude: null, longitude: null });
            },
            {
                enableHighAccuracy: false,
                timeout: 5000,
                maximumAge: 600000
            }
        );
    });
}

async function enviarSuscripcion(subscription, latitude, longitude) {
    try {
        const subscriptionData = subscription.toJSON();

        const response = await fetch('/subscriptions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                subscription: {
                    endpoint: subscriptionData.endpoint,
                    keys: subscriptionData.keys,
                    latitude: latitude,
                    longitude: longitude
                }
            })
        });

        const data = await response.json();

        if (data.success) {
            if (data.reload && data.state_id) {
                const url = new URL(window.location.href);
                url.searchParams.set('state_id', data.state_id);
                window.history.replaceState({}, '', url.toString());
            }
        } else {
            console.error("Error al enviar la suscripción:", data.error);
        }
    } catch (error) {
        console.error("Error al procesar la solicitud:", error);
    }
}

// Función auxiliar para convertir VAPID a Uint8Array
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}
